<template>
  <div class="flip-card col-12 col-sm-6 col-md-4 col-lg-3">
    <div class="flip-card-inner">
      <div class="flip-card-front">
        <img :src="imgSrc" :onerror="`this.src='${defaultImg}'`" alt="Image" />
        <div class="flip-card-title">
          <h4 class="cut-1line" :title="activityData.activityNameCurrent">
            {{ activityData.activityNameCurrent }}
          </h4>
        </div>
      </div>
      <div class="flip-card-back">
        <div class="flip-card-back-icons">
          <button
            v-b-modal.ActivityInfo
            class="btn p-0"
            :title="$t('info')"
            @click="setActivityData"
          >
            <img src="@/assets/images/info.svg" class="icon-lg" />
          </button>
          <router-link
            :to="{
              name: 'ActivityEdit',
              params: { activityToken: `${activityData.activityToken}` },
            }"
            :title="$t('edit')"
          >
            <img src="@/assets/images/pencil.svg" class="icon-lg" />
          </router-link>

          <button
            v-b-modal.ActivityDelete
            class="btn p-0"
            :title="$t('delete')"
            @click="setActivityData"
          >
            <img src="@/assets/images/trash.svg" class="icon-lg" />
          </button>
        </div>
        <div class="flip-card-title">
          <h4 class="cut-1line" :title="activityData.activityNameCurrent">
            {{ activityData.activityNameCurrent }}
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/utils/constants";
import DEFAULT_IMG_CLIENT from "@/assets/images/type.svg";

export default {
  name: "ActivityCard",
  data() {
    return {
      language: localStorage.getItem("userLanguage") || "ar",
      defaultImg: DEFAULT_IMG_CLIENT,
    };
  },
  props: ["activityData"],
  methods: {
    setActivityData() {
      this.$emit("setActivityData", this.activityData);
    },
  },
  computed: {
    imgSrc: function () {
      return BASE_URL + this.activityData.activityImagePath;
    },
  },
};
</script>

<style lang="scss"></style>
